import { AssetManagementRepository } from '../data/asset-management-repository';
import { RollbackAssetResponse } from '../types/asset-types';

/**
 * Use case for rolling back an asset to a previous version
 */
export class RollbackAssetUseCase {
  constructor(private readonly repository: AssetManagementRepository) {}

  async execute(assetId: number, versionId: number): Promise<RollbackAssetResponse> {
    return this.repository.rollbackAsset(assetId, versionId);
  }
}
